/*eslint-disable*/
import * as types from './../mutation-types'

const state = {
  searchParams: {}
};


const mutations = {
  [types.SET_SEARCH_PARAMS](state, {key, value}) {
    state.searchParams[key] = value;
  }
};

export default {
  state,
  mutations
}